import { getDefaultConfig, getAllHeaders } from '.';
import { LayerType } from './types';
import { MVTLayer } from '@deck.gl/geo-layers';
import type { Feature } from 'geojson';
import { type _Tile2DHeader } from '@deck.gl/geo-layers';
import type { Dispatch, SetStateAction } from 'react';

type SatelliteMetadataTile = _Tile2DHeader & {
  dataInWGS84?: Feature[];
};

export const getSatelliteBaseMetadataLayer = (
  user: string,
  setSatelliteMetadata: Dispatch<SetStateAction<Feature[]>>,
  minZoom = 16,
  maxZoom = 18
) => {
  const loadOptions = {
    fetch: {
      method: 'GET',
      headers: getAllHeaders({}, user),
    },
  };

  const onViewportLoad = (tiles: SatelliteMetadataTile[]) => {
    setSatelliteMetadata([]);
    tiles.forEach((tile) => {
      // data in world coordinates (WGS84)
      const dataInWGS84 = tile.dataInWGS84;
      if (dataInWGS84) {
        setSatelliteMetadata((prev) => [...prev, ...dataInWGS84]);
      }
    });
  };

  const id = LayerType[LayerType.satellite_metadata];
  return new MVTLayer({
    ...getDefaultConfig(id, user),
    id,
    loadOptions,
    minZoom,
    maxZoom,
    pickable: false,
    binary: true,
    opacity: 0,
    onViewportLoad,
  });
};
